import { Text } from "preact-i18n";
export default {
  WRONG_PASSWORD: (
    <Text id="errors.wrongPassword">
      Password is not valid for the decryption.
    </Text>
  )
};
